// Must stay in sync with the backend source of truth:
// BHA-backend/models/ondemand/PayScale.js → HCW_POSITIONS.
export const HCW_POSITIONS = [
  'Community Ambassador',
  'Community Health Worker',
  'Medical Assistant',
  'Phlebotomist',
  'LVN/LPN',
  'RN',
  'Nurse Practitioner (NP)',
  'Physician Assistant (PA)',
  'MD/DO',
  'Mental health provider',
  'CNA',
  'Pharmacists',
  'Volunteer',
  'Other'
];
